import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSetLossLimits = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetLossLimitsRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetLossLimitsRequestData, TServerSendResponse>({
            ID: 35646,
            responses: [35647, 35648],
            description: 'Set loss limits',
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
